import React from 'react'

import useActions from '../../../../hooks/useActions'
import useHistory from '../../../../hooks/useHistory'
import useScrollToRef from '../../../../hooks/useScrollToRef'
import useScrollToTop from '../../../../hooks/useScrollToTop'
import useAuthToken from '../../../../hooks/useAuthToken'
import { Button } from '../../../../components'
import { loginActions } from '../../../../redux/ducks/login'
import { useSelector } from 'react-redux'
import { Roles } from '../../../../constants/roles'

import ecbrLogo from '../../../../assets/Icons/ecbrLogo.svg'

import * as S from './styles'

const LoggedOutHeader = ({ landingPageRefs }) => {
  const { logout } = useActions(loginActions)
  const { isLogged } = useSelector((state) => state.login)
  const { scrollToTop } = useScrollToTop()
  const scrollToRef = useScrollToRef()
  const { role } = useAuthToken()
  const history = useHistory()
  const { certificationRef, benefitsRef } = landingPageRefs ?? {}

  const logoutHandler = async () => {
    await logout()
    history.push('/')
  }

  const isOnSignupPage = history.location.pathname
    .toLowerCase()
    .includes('/signup')

  const isOnLoginPage = history.location.pathname
    .toLowerCase()
    .includes('/login')

  return (
    <S.Header>
      <S.Logo>
        <img
          src={ecbrLogo}
          alt="ecbrDNA"
          onClick={() => {
            history.push('/')
            scrollToTop()
          }}
        />
      </S.Logo>
      <S.Middle>
        <Button
          type="button"
          variant="link"
          text="CERTIFICAÇÃO"
          width="100px"
          onClick={() => scrollToRef(certificationRef, -80)}
        />
        <Button
          type="button"
          variant="link"
          text="BENEFÍCIOS"
          width="200px"
          onClick={() => scrollToRef(benefitsRef, -80)}
        />
      </S.Middle>
      <S.Login>
        {!isLogged ? (
          <>
            {isOnSignupPage && (
              <Button
                text="JÁ SOU CADASTRADO"
                variant="outlined"
                width="200px"
                height="35px"
                onClick={() => history.push('/login')}
              />
            )}
            {isOnLoginPage && (
              <Button
                text="CRIAR CONTA"
                variant="outlined"
                width="200px"
                height="35px"
                onClick={() => history.push('/signup')}
              />
            )}
            {!isOnSignupPage && !isOnLoginPage && (
              <>
                <Button
                  type="button"
                  variant="link"
                  text="ENTRAR"
                  width="100px"
                  onClick={() => history.push('/login')}
                />
                <Button
                  text="OBTER CERTIFICAÇÃO"
                  variant="primary"
                  onClick={() => history.push('/signup')}
                />
              </>
            )}
          </>
        ) : (
          <>
            <Button
              type="button"
              variant="link"
              text="SAIR"
              width="100px"
              onClick={() => logoutHandler()}
            />
            {[Roles.ADMIN_USER, Roles.VIEWER_USER, Roles.PILLAR_OWNER].includes(
              role
            ) ? (
              <Button
                text="ÁREA DO USUÁRIO"
                variant="primary"
                onClick={() => history.push('/user')}
              />
            ) : (
              <Button
                text="PAINEL ADMINISTRATIVO"
                variant="primary"
                onClick={() => history.push('/admin')}
              />
            )}
          </>
        )}
      </S.Login>
    </S.Header>
  )
}

export default LoggedOutHeader
